var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgQuotationMarksBlue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 43 43"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#quotation_marks_blue_svg__clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1053FF",
    d: "M8.857 18.042c.525-3.297 4.647-6.82 7.87-6.895.224 0 .45-.075.6-.225.15-.075.299-.15.374-.374 1.124-2.099.525-3.748-1.35-5.097-2.173-1.574-5.62 0-7.344 1.424C4.66 10.473.238 16.693.463 22.614c-.75 3.972-.6 8.244.525 11.767.75 2.248 2.923 3.372 5.171 3.522 2.249.15 6.895.825 8.919-.524 2.023-1.35 2.173-3.973 2.398-6.22.225-2.474.9-7.121-1.199-9.07-2.099-1.873-8.094.15-7.42-4.047zm24.733 0c.524-3.297 4.646-6.82 7.87-6.895a.85.85 0 00.599-.225c.15-.075.3-.15.375-.374 1.124-2.099.524-3.748-1.35-5.097-2.173-1.574-5.62 0-7.344 1.424-4.347 3.598-8.77 9.818-8.544 15.739-.75 3.972-.6 8.244.524 11.767.75 2.248 2.923 3.372 5.172 3.522 2.248.15 6.895.825 8.918-.524 2.024-1.35 2.174-3.973 2.399-6.22.225-2.474.9-7.121-1.2-9.07-2.098-1.873-8.169.15-7.42-4.047z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "quotation_marks_blue_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h43v43H0z"
  })))));
}

export default SvgQuotationMarksBlue;